/**
 * The day a credit allowance rolls over, in the form a person reads.
 *
 * Returns undefined rather than a placeholder: a line that cannot state a real
 * date should not appear at all. Saying "resets —" is worse than saying
 * nothing, because it looks like a value we lost rather than one that does not
 * exist yet. The empty string matters specifically — `handler_me` used to send
 * `""` for a BALANCE row written without a resetAt, and `Account.test.ts` pins
 * that case.
 *
 * WHY IT LIVES HERE rather than in Account.tsx, where it was.
 *
 * `Pricing.tsx` imports it, and Pricing is a public page in the eager bundle.
 * That one import pulled the entire Account module — component and all — into
 * the first download, and kept doing so after Account was made lazy, so the
 * split silently bought nothing and the chunk list was the only place it
 * showed. Its own docstring had gone stale in the same direction: it claimed
 * the export existed "only so Account.test.ts can pin the day-one empty-string
 * case", which stopped being true when Pricing started using it.
 *
 * The standing oxlint warning on Account.tsx was pointing at exactly this — a
 * module exporting both a component and a shared function. It read as a
 * fast-refresh nicety; it was also a bundle boundary.
 */
export function formatResetDate(iso: string | undefined): string | undefined {
  if (!iso) return undefined;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toLocaleDateString("en-AU", { day: "numeric", month: "long" });
}
